import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API } from 'app/configs/api';
import handleError from '@fuse/core/errorHandler';
import jwtService from '../auth/services/jwtService';

const initialState = {
  count: null,
  loading: false,
  error: null,
};

export const fetchCount = createAsyncThunk(
  'application/fetchCount',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(API.getCount, {
        headers: {
          Authorization: `Bearer ${jwtService.getAccessToken()}`,
        },
      });

      return res.data?.count ?? null;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error?.response?.data || 'API error');
    }
  }
);

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    setCount: (state, action) => {
      state.count = action.payload;
    },
    decrementCount: (state) => {
      if (state.count !== null && state.count > 0) {
        state.count -= 1;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCount.fulfilled, (state, action) => {
        state.loading = false;
        state.count = action.payload;
      })
      .addCase(fetchCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setCount, decrementCount } = applicationSlice.actions;
export default applicationSlice.reducer;
